<template>
  <div>
    <v-container fluid grid-list-md class="padding_10">
      <v-expansion-panel class="mb-4">
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>Filters</div>
          </template>
          <v-layout row wrap style="padding: 0px 10px 0px 10px; align-content: center;">

            <v-flex sm12 md6 lg6>
              <v-autocomplete
                  :items="train_lists"
                  item-text="number"
                  item-value="number"
                  flat
                  v-model="filters.number"
                  label="Number"
                  chips
                  clearable
                  name="name"
                  solo
                  :disabled="searchingItem == true"
              ></v-autocomplete>
            </v-flex>

            <v-flex sm12 md6 lg4 style="display: flex; justify-content: center; margin-top: -17px;">
              <v-btn @click="applyFilters" color="primary" class="mt-3">
                Filter
              </v-btn>
            </v-flex>
          </v-layout>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-data-table
              no-results-text="Loading... Please wait"
              :headers="headers"
              :items="trainRakeList"
              item-key="id"
              :loading="loader.train_rake_list"
              :pagination.sync="pagination"
              :total-items="total_items"
              :rows-per-page-items="[10, 20, 50, 100]">
            <template slot="items" slot-scope="props">

              <td v-if="props.item.tracking_data" @click="activateShowDialog(props.item.tracking_data.train_number)">
                <a>{{ props.item.tracking_data.train_number }}</a>
              </td>
              <td v-else> {{ props.item.train_number}} </td>

              <td v-if="props.item.tracking_data">
                  {{ props.item.rake_data.rake_number }}
              </td>
              <td v-else>
                {{ "-" }}
              </td>

              <td v-if="props.item.tracking_data">
                  {{ props.item.tracking_data.device_id }}
              </td>
              <td v-else>
                {{ "-" }}
              </td>

              <td v-if="props.item.rake_data">
                  {{ moment(props.item.tracking_data.updated_at).format('ddd, Do MMM YYYY HH:mm A') }}
              </td>
              <td v-else>
                {{ "-" }}
              </td>

            </template>
          </v-data-table>
        </v-flex>
      </v-layout>



      <v-dialog v-model="showTrackingDetailDialog" max-width="600px" scrollable>
        <v-card>
          <v-card-title>
            <v-flex xs12 md12 lg12 style="display: flex; justify-content: space-between;">
              <h4 class="heading_text" style="padding-bottom: 0px;">Tracking Details</h4>
              <v-btn icon @click="showTrackingDetailDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 500px;">
            <v-layout row wrap>

              <v-flex xs12 md12 lg12 style="display: flex;">
                <v-flex xs12 md6 lg4>
                  <label>Train Number : </label>
                </v-flex>
                <v-flex xs12 md6 lg8>
                  <v-text-field
                      name="train_number"
                      v-model="show_tracking_object.train_number"
                      label="Train Number" disabled
                      solo flat>
                  </v-text-field>
                </v-flex>
              </v-flex>

              <v-flex xs12 md12 lg12 style="display: flex;">
                <v-flex xs12 md6 lg4>
                  <label>Rake Number : </label>
                </v-flex>
                <v-flex xs12 md6 lg8>
                  <v-text-field
                      name="rake_number"
                      v-model="show_tracking_object.rake_number"
                      label="Rake Number" disabled
                      solo flat>
                  </v-text-field>
                </v-flex>
              </v-flex>

              <v-flex xs12 md12 lg12 style="display: flex;">
                <v-flex xs12 md6 lg4>
                  <label>Device Id : </label>
                </v-flex>
                <v-flex xs12 md6 lg8>
                  <v-text-field
                      name="device_id"
                      v-model="show_tracking_object.device_id"
                      label="Device Id" disabled
                      solo flat>
                  </v-text-field>
                </v-flex>
              </v-flex>

              <v-flex xs12 md12 lg12 style="display: flex;">
                <v-flex xs12 md6 lg4>
                  <label>Latitude : </label>
                </v-flex>
                <v-flex xs12 md6 lg8>
                  <v-text-field
                      name="latitude"
                      v-model="show_tracking_object.latitude"
                      label="Latitude" disabled
                      solo flat>
                  </v-text-field>
                </v-flex>
              </v-flex>

              <v-flex xs12 md12 lg12 style="display: flex;">
                <v-flex xs12 md6 lg4>
                  <label>Longitude : </label>
                </v-flex>
                <v-flex xs12 md6 lg8>
                  <v-text-field
                      name="longitude"
                      v-model="show_tracking_object.longitude"
                      label="Longitude" disabled
                      solo flat>
                  </v-text-field>
                </v-flex>
              </v-flex>

              <v-flex xs12 md12 lg12 style="display: flex;">
                <v-flex xs12 md6 lg4>
                  <label>Address : </label>
                </v-flex>
                <v-flex xs12 md6 lg8>
                  <v-textarea
                      name="address"
                      rows="3"
                      v-model="show_tracking_object.address"
                      label="Address" disabled
                      solo flat>
                  </v-textarea>
                </v-flex>
              </v-flex>

              <v-flex xs12 md12 lg12 style="display: flex;">
                <v-flex xs12 md6 lg4>
                  <label>Last Tracking Station : </label>
                </v-flex>
                <v-flex xs12 md6 lg8>
                  <v-text-field
                      name="Last_Tracking_Station"
                      v-model="show_tracking_object.last_tracking_station"
                      label="Last Tracking Station" disabled
                      solo flat>
                  </v-text-field>
                </v-flex>
              </v-flex>

              <v-flex xs12 md12 lg12 style="display: flex;">
                <v-flex xs12 md6 lg4>
                  <label>Last Updated At : </label>
                </v-flex>
                <v-flex xs12 md6 lg8>
                  <v-text-field
                      name="Last_Updated_At"
                      v-model="show_tracking_object.last_tracking_at"
                      label="Last Updated At" disabled
                      solo flat>
                  </v-text-field>
                </v-flex>
              </v-flex>

            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" small
                   @click="showTrackingDetailDialog = false;">Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
          :timeout="snackBar.timeout"
          :color="snackBar.color"
          :top="snackBar.top"
          :bottom="snackBar.bottom"
          :left="snackBar.left"
          :right="snackBar.right"
          v-model="snackBar.show">
        {{ snackBar.message }}
        <v-btn dark flat @click.native="snackBar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>

    </v-container>
  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      trainRakeList: [],
      filters: {
        number: ''
      },
      loader: {
        train_list: false,
        train_rake_list: false,
      },
      snackBar: {
        show: false,
        message: "",
        timeout: 4000,
        top: true,
        right: true,
        bottom: false,
        left: false,
        color: "",
      },
      total_items: 10,
      pagination: { sortBy: "updated_at", descending: true, rowsPerPage: 10 },
      headers: [
        {
          text: "Train Number",
          value: "train_number",
          align: "left",
          sortable: false,
        },
        {
          text: "Rake Number",
          value: "rake_number",
          align: "left",
          sortable: true,
        },
        {
          text: "Device Id",
          value: "device_id",
          align: "left",
          sortable: false,
        },
        {
          text: "Updated_at",
          value: "updated_at",
          align: "left",
          sortable: false,
        },
      ],
      tracking_detail_dialog: false,
      showTrackingDetailDialog: false,
      show_tracking_object: [],
      train_lists: [],
      searchingItem: false,

    }
  },
  watch: {
    pagination: {
      handler() {
        this.getList();
      }
    }
  },
  methods: {
    applyFilters() {
      this.getList()
    },
    getList() {
      this.loader.train_rake_list = true;
      this.searchingItem = true;
      this.pagination.filters = Object.assign({}, this.filters);
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/train-wise-rake-list`, {
        params: this.pagination,
      }).then((response) => {
        if (response.data.status == 1) {
          this.loader.train_rake_list = false;
          this.searchingItem = false;
          this.trainRakeList = response.data.data;
          this.total_items = response.data.total.total;
        }else if(response.data.status == 0){
          this.loader.train_rake_list = false;
          this.searchingItem = false;
        }
      }).catch((error) => {
        this.stopLoading();
        this.snackBar.message = "Something went wrong.";
        this.snackBar.display = true;
      });
    },
    activateShowDialog(number) {
      this.startLoading();
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/show-train-wise-rake-data/` + number, {
        headers: this.$headers,
      }).then((response) => {
        if (response.data.status == 1) {

          this.show_tracking_object = response.data.data;

          const url = 'https://nominatim.openstreetmap.org/reverse?lat=' +
              this.show_tracking_object.tracking_data.latitude + '&lon=' + this.show_tracking_object.tracking_data.longitude +
              '&zoom=18&format=json';
          axios
              .get(url)
              .then(response => {
                setTimeout(()=>{
                  this.show_tracking_object.address = response.data.display_name;
                  this.stopLoading();
                  this.showTrackingDetailDialog = true;
                },1000);

              });

          this.show_tracking_object.train_number = this.show_tracking_object.tracking_data.train_number;
          this.show_tracking_object.rake_number = this.show_tracking_object.rake_data.rake_number;
          this.show_tracking_object.device_id = this.show_tracking_object.tracking_data.device_id;
          this.show_tracking_object.latitude = this.show_tracking_object.tracking_data.latitude;
          this.show_tracking_object.longitude = this.show_tracking_object.tracking_data.longitude;
          this.show_tracking_object.last_tracking_at =
              this.moment(this.show_tracking_object.tracking_data.time).format('ddd, Do MMM YYYY HH:mm A');
          this.show_tracking_object.last_tracking_station = this.show_tracking_object.tracking_data.station_code;

        } else if (response.data.status == 0) {
          this.stopLoading();
          this.snackBar.message = response.data.message;
          this.snackBar.display = true;
        }
      }).catch((error) => {
        this.stopLoading();
        this.snackBar.message = "Something went wrong.";
        this.snackBar.display = true;
      });
    },
    getTrainList(){
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/train-codes`,
          {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.train_lists = response.data.train_codes;
            }

          })
    }
  },
  mounted() {
    this.getTrainList();
  }
}
</script>

<style scoped>

</style>
